import Box from '@mui/material/Box';

import { Button } from '@/components/ui/Button';
import { useToast } from '@/components/ui/useToast';

import { State } from '../State';

export function ToastExamples() {
  const toast = useToast();

  return (
    <State
      title="Success and error"
      note="One at a time, six seconds, paused while the pointer or keyboard is on it."
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="secondary"
          onClick={() => toast.show({ message: 'Profile saved.' })}
        >
          Show a success toast
        </Button>
        <Button
          variant="secondary"
          onClick={() =>
            toast.show({ message: 'That could not be saved.', severity: 'error' })
          }
        >
          Show an error toast
        </Button>
      </Box>
    </State>
  );
}
